// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"113":"5f525660","514":"a2930d21"}[chunkId] + ".css";
};